export const panel = {
	closeEvent: {
		message:
			"¿Está seguro de que quiere cerrar el evento? Esto hará checkout de todos los usuarios y cerrará el reporte, el inventario y las cajas.",
		finishedActivityDevices:
			"¡Existen {{finishedActivityDevices}} PDV's con operación abierta!",
		eventNameMessage: "Ingrese el nombre del evento para confirmar el cierre",
		emptyName: "El nombre del evento está vacío",
		incorectName: "El nombre del evento es incorrecto",
	},
	deleteEvent: {
		confirm:
			"¿Está seguro de que quiere eliminar el evento? Esta será una acción permanente",
	},
	eventNotOpen: "Este evento aún no ha sido abierto",
	openEvent: "Abrir evento",
	eventStatus: "Estado del evento",
	open: "Abierto",
	finished: "Cerrado",
	canceled: "Cancelado",
	notOpened: "No abierto",
	openedBy: "Abierto por",
	finishedActivityText: "{{activeDevices}} PDVs con operación abierta",
	closeEventButton: "Cerrar evento",
	removeEventButton: "Eliminar evento",
	goTo: "ir a",
	importConsumption: {
		title: "Importar Consumo",
		consumptionType: "Tipo de consumo",
		normal: "Normal",
		consumption: "Consumo",
		confirm: "Confirmar",
		consumptionErrors: "Consumos que fallaron",
		document: "RFC",
		reason: "Motivo",
		import: "Importar consumo",
		balanceType: "Tipo de saldo",
		columns: {
			reason: "Razón",
			value: "Valor",
			document: "RFC",
			name: "Nombre",
			email: "Correo electrónico",
			phone: "Teléfono",
			isForeign: "¿Es extranjero?",
			gender: "Género",
		},
		successNotification: "¡Consumo importado!",
		warningNotification: "Los datos no fueron enviados. Algunos consumos fallaron",
		recharge: "Recarga",
		minimumConsumption: "Consumo anticipado",
		bonus: "Bono",
		spreadsheet: "Spreadsheet",
		user: "Usuario",
	},
	importConsumptionCardsGroup: {
		title: "Grupo de tarjetas",
		fields: {
			group: {
				label: "Nombre del grupo de tarjetas",
				required: "Seleccione un grupo de tarjetas",
			},
			balanceType: {
				label: "Tipo de Saldo",
				required: "El valor del saldo debe ser mayor que cero",
			},
			balance: { label: "Valor del Saldo" },
		},
	},
	importConsumptionZigCode: {
		title: "Zig Code",
		fileName: "Spreadsheet de Consumo",
		rechargeSuccess: "¡Recarga efectuada con éxito!",
		balanceType: "Tipo de Saldo",
		columns: {
			reason: "Razón",
			value: "Valor",
			zigCode: "Zig Code",
		},
	},
	importConsumptionUser: {
		reason: "Motivo",
		document: "Documento",
		paymentMethod: "Método de pago",
		value: "Valor de la recarga",
		submitRecharge: "Recargar ",
		documentError: "Documento es obligatorio",
		paymentMethodError: "Método de pago es obligatorio",
		valueError: "Valor de la recarga es obligatorio",
		recharge: "Recarga",
		minimumConsumption: "Consumo anticipado",
		bonus: "Bono",
		documentType: "Tipo de documento",
		saveToDigitalCardQuestion:
			"¿Desea guardar la recarga en la tarjeta digital del cliente, si tiene una?",
		saveToDigitalCardQuestionPlural:
			"¿Desea guardar las recargas en las tarjetas digitales de los clientes, si las tienen?",
	},
	publicCard: {
		title: "Público",
		totalPublic: "{{totalPublic}} estuvieron en el evento",
		allInsideText: "aún están disfrutando",
		allOutsideText: "ya se fueron",
		newPublicText: "nuevos clientes",
		oldPublicText: "regresaron",
		capacity: "Capacidad",
		people: "personas",
		genderCard: {
			invoice: "Facturado",
			averageTicket: "Ticket Promedio",
			zeroTicket: "Ticket Cero",
			realTicket: "Ticket Real",
			male: "Hombres",
			female: "Mujeres",
			other: "Otros",
		},
	},
	totalReceiptCard: {
		title: "Financiero",
		notIdealStateMessage:
			"Esta información solo está disponible en eventos a partir del 01/08/2017",
		averageTicket: "Ticket Promedio",
		zeroTicket: "Ticket Cero",
		realTicket: "Ticket Real",
		receipt: "Ingreso",
		operationTable: {
			title: "Operación",
			operationMode: "Modo de operación",
			zigTable: "Zig Mesa",
			zigCard: "Zig Card",
			zigDelivery: "Zig Delivery",
			total: "Total",
			invoicing: "Facturación",
		},
		column: {
			title: "Modo De Pago",
			bar: "Bar",
			value: "Valor",
			entrance: "Entrada",
			opened: "Cuentas abiertas",
			total: "Total",
			tableRow: {
				app: "Aplicación",
				rappi: "Rappi Pay",
				ame: "Ame",
				uber: "Uber",
				ifood: "Ifood",
				deliveryOnline: "Delivery Online",
				delivery: "Delivery",
				cash: "Efectivo",
				credit: "Crédito",
				debit: "Débito",
				voucher: "Voucher",
				anticipated: "Anticipado",
				postEvent: "Pagado después del evento",
				pix: "Pix",
				integratedFoodVoucher: "Vale de Alimentación",
				mbway: "Mbway",
				online: "En línea",
			},
			entranceConsumptions: "Consumo taquilla",
			extraConsumptions: "Consumo extra",
			adjustedReceipt: "Ingreso ajustado",
			rechargeReturned: "Recargas devueltas",
			invoicing: "Facturación",
		},
		errorContent: "¡Error!",
		emptyContent: "No hay nada que mostrar aquí",
		timelineCard: {
			consumption: "Consumo",
			period: "Período",
			recharge: "Recargas",
			zigCardConsumption: "Consumo en Zig Card",
			tableConsumption: "Consumo en Zig Mesa",
			tooltipMessage: "{{titleMap}} en el período de {{start}} a {{end}}",
			value: "Valor consumido",
		},
	},
	topClientsCard: {
		title: "Clientes que más consumen",
		clientInfo: "Información del cliente",
		clients: "Clientes",
		count: "Consumo",
	},
	vendorsResumeCard: {
		title: "Ventas por vendors",
		name: "Vendors",
		totalSold: "Total vendido",
	},
	topProductsPriceCard: {
		title: "Productos por representación en ventas",
		allProductsSold: "Todos los productos vendidos",
		altNavlink: "Enlace de navegación para reporte de todos los productos vendidos",
		noData: "Sin Datos",
		other: "Otros",
		products: "Productos",
		quantity: "Cantidad",
		consumption: "Consumo",
		unavailable: "No disponible",
	},
	totalOpenedTable: "mesa abierta",
	totalOpenedTables: "mesas abiertas",
	totalTables: "Total de mesas",
	editEvent: {
		title: "Editar evento",
		confirm: "Confirmar",
		passTemplate: "ID del modelo del pase",
	},
	zigMesaOperationMode: {
		message: "Estado del servidor en el PDV",
		online: "En línea",
		local: "Local",
	},
	operationCard: {
		title: "Operación Zig Mesa",
		peopleSingle: "Persona",
		peoplePlural: "Personas",
		tableSingle: "Mesa",
		tablePlural: "Mesas",
		time: "Horario",
	},
};
